export interface Route {
  link: string;
  title: string;
}

export const integration: Record<string, Route> = {
  start: { link: '/', title: 'Start' },
  download: { link: '/download', title: 'Download' },
  templates: {
    link: '/corporate-design/templates',
    title: 'Templates',
  },
};

export const corporateDesign: Record<string, Route> = {
  webdienste: { link: '/corporate-design/webdienste', title: 'Webdienste' },
  toolsAndServices: {
    link: '/corporate-design/tools-and-services',
    title: 'Tools & Services',
  },
};

export const basicElements: Record<string, Route> = {
  cookie_consent: {
    link: '/basic-elements/cookie-hinweis',
    title: 'Cookie-Hinweis',
  },
  colors: { link: '/basic-elements/colors', title: 'Farben' },
  forms: { link: '/basic-elements/formulare', title: 'Formulare' },
  form_validation: {
    link: '/basic-elements/form-validierung',
    title: 'Formular-Validierung',
  },
  logos: {
    link: '/basic-elements/wort-und-bildmarken',
    title: 'Wort-/Bildmarken',
  },
  tools_footer: {
    link: '/basic-elements/tools-footer',
    title: 'Tools-Footer',
  },
  tools_header: {
    link: '/basic-elements/tools-header',
    title: 'Tools-Header',
  },
  typography: { link: '/basic-elements/typography', title: 'Typografie' },
  webdienst_footer: {
    link: '/basic-elements/webdienst-footer',
    title: 'Webdienst-Footer',
  },
  webdienst_header: {
    link: '/basic-elements/webdienst-header',
    title: 'Webdienst-Header',
  },
};

export const components: Record<string, Route> = {
  accordion: { link: '/components/accordion', title: 'Accordion' },
  alerts: { link: '/components/alerts', title: 'Alerts' },
  backtotop: { link: '/components/back-to-top', title: 'Back-To-Top' },
  badges: { link: '/components/badges', title: 'Badges' },
  breadcrumbs: { link: '/components/breadcrumbs', title: 'Breadcrumbs' },
  buttons: { link: '/components/buttons', title: 'Buttons' },
  carousel: { link: '/components/carousel', title: 'Carousel' },
  collapse: { link: '/components/collapse', title: 'Collapse' },
  dropdown: { link: '/components/dropdown', title: 'Dropdown' },
  icons: { link: '/components/icons', title: 'Icons' },
  images: { link: '/components/images', title: 'Images' },
  spinner: { link: '/components/spinner', title: 'Loading spinner' },
  modal: { link: '/components/modal', title: 'Modal' },
  navtabs: { link: '/components/navtabs', title: 'Nav-Tabs' },
  offcanvas: { link: '/components/offcanvas', title: 'Offcanvas' },
  pagination: { link: '/components/pagination', title: 'Pagination' },
  popover: { link: '/components/popover', title: 'Popover' },
  progressbar: { link: '/components/progressbar', title: 'Progressbar' },
  tables: { link: '/components/tables', title: 'Tables' },
  teaser: { link: '/components/teaser', title: 'Teasers' },
  testimonial: { link: '/components/testimonial', title: 'Testimonial' },
  tooltip: { link: '/components/tooltip', title: 'Tooltip' },
  videos: { link: '/components/videos', title: 'Videos' },
};

export const navIntegration = Object.entries(integration).slice(0, 3);
export const navCorporateDesign = Object.entries(corporateDesign).slice(0, 2);
export const navBasicElements = Object.entries(basicElements).slice(0, 10);
export const navComponents = Object.entries(components).slice(0, 24);
